import { useState } from 'react';
import { usersAPI } from "@/api";
import { AuthService, idUserAuthorizedOnTheAuthorizationPage } from "@/services/AuthService";
import { useAddAlert } from "@/hooks/useAddAlert";

export const useAccountActions = () => {
  const addAlert = useAddAlert();
  
  const [loadingAccounts, setLoadingAccounts] = useState([]);
  
  const disconnectAccount = async (id) => {
      setLoadingAccounts(prev => [...prev, id]);
      try {
          const { data } = await usersAPI.disconnectAccount({id, user_id: localStorage.getItem(idUserAuthorizedOnTheAuthorizationPage) || undefined});
          if(data?.status === 'success'){
              return { success: true };
          }
          else{
              addAlert({title: 'Ошибка', text: 'При выходе из ЛК произошла ошибка', type: 'error'});
              return { success: false };
          }
      } finally {
          setLoadingAccounts(prev => prev?.filter(el => el != id));
      }
  };

  const onLogin = async (userId) => {
      setLoadingAccounts(prev => [...prev, userId]);
      try {
          const response = await usersAPI.authorizationMobile({id: userId});

          if(response?.data?.user?.id){
              AuthService.auth(
                  response.data.user,
                  response.data.token,
                  response.data?.refresh_token,
              );
              window.location.href = '/';
          }
          else{
              addAlert({title: 'Ошибка', text: 'При входе в ЛК произошла ошибка', type: 'error'});
          }
      } catch (error) {
          addAlert({
              title: 'Ошибка',
              text: error?.message || 'При входе в ЛК произошла ошибка',
              type: 'error',
          });
      } finally {
          setLoadingAccounts(prev => prev?.filter(el => el != userId));
      }
  };

  return {loadingAccounts, disconnectAccount, onLogin};
};
